export const unwrapData = (axiosResponse) => axiosResponse?.data?.data ?? null;

export const unwrapList = (axiosResponse) => {
  const data = unwrapData(axiosResponse);
  return Array.isArray(data) ? data : [];
};

export const unwrapRecords = (axiosResponse) => {
  const records = unwrapData(axiosResponse);
  if (!records || typeof records !== 'object') {
    return { rows: [], total: 0, page: 0, size: 0 };
  }
  return {
    rows: Array.isArray(records.data) ? records.data : [],
    total: Number(records.records) || 0,
    page: records.page ?? 0,
    size: records.size ?? 0,
  };
};

export const apiErrorMessage = (error, fallback) => {
  if (!error?.response && error?.message === 'Network Error') {
    return 'Cannot reach the API server. Start the Spring Boot backend on port 8067 and restart the React dev server.';
  }
  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    return (
      error?.response?.data?.message ||
      'Your session may have expired or the tenant header is missing. Sign in again via your tenant login URL, then retry.'
    );
  }
  if (status === 400 && error?.response?.data?.message?.includes('X-TenantID')) {
    return error.response.data.message;
  }
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  );
};

/** Normalize lookup ids for MUI Select (API may return numbers; Select values must match). */
export const normalizeLookupId = (id) => {
  if (id == null || id === '') return null;
  const n = Number(id);
  return Number.isNaN(n) ? id : n;
};

export const normalizeLookupIds = (ids) =>
  (ids ?? []).map(normalizeLookupId).filter((id) => id != null);

export const unwrapCreatedEntity = (axiosResponse) => {
  const data = unwrapData(axiosResponse);
  if (!data || typeof data !== 'object') return null;
  const id = normalizeLookupId(data.id);
  return id != null ? { ...data, id } : data;
};

export const isEmptyFieldValue = (field, value) => {
  if (field.type === 'boolean') return false;
  if (field.type === 'multiEnum' || field.type === 'multiLookupSelect') {
    return !Array.isArray(value) || value.length === 0;
  }
  if (value == null) return true;
  return String(value).trim() === '';
};
